import { useEffect, useRef, useState } from "react";
import { AlteracaoCadastral, Fornecedor } from "../types";
import {} from "react-icons";
import { FiEdit } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import useApp from "../context/AppContext";
import { api } from "../utils/api";
import { fillString } from "../utils/functions";
import { FaCheckCircle, FaExclamationTriangle, FaTimesCircle } from "react-icons/fa";
import InputMask from "react-input-mask";

type CadastroProps = {
  fornecedor: Fornecedor;
};

const CadastroForm = (props: CadastroProps) => {
  const { fornecedor } = props;
  const refRazao = useRef<HTMLInputElement>(null);
  const refInscMun = useRef<HTMLInputElement>(null);
  const refInscEst = useRef<HTMLInputElement>(null);
  const refEndereco = useRef<HTMLInputElement>(null);

  const navigate = useNavigate();
  const { alteracoes, usuario, showModalMessage, showModalError, setLoading } = useApp();

  const [razaoSocial, setRazaoSocial] = useState(fornecedor.razaoSocial);
  const [inscricaoMunicipal, setInscricaoMunicipal] = useState(fornecedor.inscricaoMunicipal);
  const [inscricaoEstadual, setInscricaoEstadual] = useState(fornecedor.inscricaoEstadual);
  const [email, setEmail] = useState(fornecedor.email);
  const [tipoLogradouro, setTipoLogradouro] = useState(fornecedor.tipoLogradouro);
  const [rua, setRua] = useState(fornecedor.rua);
  const [numero, setNumero] = useState(fornecedor.numero);
  const [cep, setCep] = useState(fornecedor.cep);
  const [complemento, setComplemento] = useState(fornecedor.complemento);
  const [bairro, setBairro] = useState(fornecedor.bairro);
  const [cidade, setCidade] = useState(fornecedor.cidade);
  const [estado, setEstado] = useState(fornecedor.estado);
  const [canEdit,setCanEdit] = useState(true);

  const [showAnexo, setShowAnexo] = useState(false);
  const [showAnexoInscMun, setShowAnexoInscMun] = useState(false);
  const [showAnexoInscEst, setShowAnexoInscEst] = useState(false);
  const [showAnexoEndereco, setShowAnexoEndereco] = useState(false);
  const [razaoDisabled, setRazaoDisabled] = useState(
    refRazao.current?.files?.length === undefined || refRazao.current?.files?.length <= 0
  );
  const [inscMunDisabled, setInscMunDisabled] = useState(
    refInscMun.current?.files?.length === undefined || refInscMun.current?.files?.length <= 0
  );
  const [inscEstDisabled, setInscEstDisabled] = useState(
    refInscEst.current?.files?.length === undefined || refInscEst.current?.files?.length <= 0
  );
  const [tipoEndereco, setEnderecoDisabled] = useState(
    refEndereco.current?.files?.length === undefined || refEndereco.current?.files?.length <= 0
  );

  useEffect(() => {
    (fornecedor.razaoSocial!== null) && setRazaoSocial(fornecedor.razaoSocial);
    (fornecedor.inscricaoEstadual!== null) && setInscricaoEstadual(fornecedor.inscricaoEstadual);
    (fornecedor.inscricaoMunicipal!== null) && setInscricaoMunicipal(fornecedor.inscricaoMunicipal === null ? '' : fornecedor.inscricaoMunicipal );
    (fornecedor.email!== null) && setEmail(fornecedor.email);
    (fornecedor.tipoLogradouro!== null) && setTipoLogradouro(fornecedor.tipoLogradouro);
    (fornecedor.rua!== null) && setRua(fornecedor.rua);
    (fornecedor.numero!== null) && setNumero(fornecedor.numero);
    (fornecedor.cep!== null) && setCep(fornecedor.cep);
    (fornecedor.complemento!== null) && setComplemento(fornecedor.complemento);
    (fornecedor.bairro!== null) && setBairro(fornecedor.bairro);
    (fornecedor.cidade!== null) && setCidade(fornecedor.cidade);
    (fornecedor.estado!== null) && setEstado(fornecedor.estado);
    
    setCanEdit(alteracoes?.status !== "PENDENTE")
  }, [props.fornecedor,alteracoes]);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    setLoading(true);
    const formData = new FormData();
    if (refRazao.current?.files && refRazao.current.files[0] !== undefined)
      formData.append("anexoRazaoSocial", refRazao.current.files[0]);
    if (refInscMun.current?.files && refInscMun.current.files[0] !== undefined)
      formData.append("anexoInscricaoMunicipal", refInscMun.current.files[0]);
    if (refInscEst.current?.files && refInscEst.current.files[0] !== undefined)
      formData.append("anexoInscricaoEstadual", refInscEst.current.files[0]);
    if (refEndereco.current?.files && refEndereco.current.files[0] !== undefined)
      formData.append("anexoEndereco", refEndereco.current.files[0]);


    razaoSocial && formData.append("razaoSocial", razaoSocial);
    inscricaoMunicipal && formData.append("inscricaoMunicipal", inscricaoMunicipal);
    inscricaoEstadual && formData.append("inscricaoEstadual", inscricaoEstadual);
    email && formData.append("email", email);
    tipoLogradouro && formData.append("tipoLogradouro", tipoLogradouro);
    rua && formData.append("rua", rua);
    numero && formData.append("numero", numero);
    complemento && formData.append("complemento", complemento);
    cep && formData.append("cep", cep);
    bairro && formData.append("bairro", bairro);
    cidade && formData.append("cidade", cidade);
    estado && formData.append("estado", estado);

    if(fornecedor.razaoSocial === razaoSocial && fillString(fornecedor.inscricaoMunicipal) === inscricaoMunicipal 
      && fillString(fornecedor.inscricaoEstadual) === inscricaoEstadual && fillString(fornecedor.email) === email && fillString(fornecedor.tipoLogradouro) === tipoLogradouro 
      && fillString(fornecedor.rua) === rua && fillString(fornecedor.numero) === numero && fillString(fornecedor.complemento) === complemento && fillString(fornecedor.cep) === cep 
      && fillString(fornecedor.bairro) === bairro && fillString(fornecedor.cidade) === cidade && fillString(fornecedor.estado) === estado){
      showModalError("Atenção! Nenhuma informação foi alterada. Altere ao menos um campo para realizar a solicitação.");
      e.preventDefault();
      return;
    }

    if((fornecedor.tipoLogradouro !== tipoLogradouro || fornecedor.rua !== rua || fornecedor.numero !== numero || 
        fornecedor.complemento !== complemento || fornecedor.cep !== cep || fornecedor.bairro !== bairro ||
        fornecedor.cidade !== cidade || fornecedor.estado !== estado) && (refEndereco.current?.files?.length === undefined || refEndereco.current?.files?.length <= 0)){
      showModalError("Atenção! Dados de endereço alterados. Anexe um arquivo para realizar a solicitação.");
      e.preventDefault();
      return;
    }

    if((fillString(fornecedor.razaoSocial) !== fillString(razaoSocial)) && (refRazao.current?.files?.length === undefined || refRazao.current?.files?.length <= 0)
      || (fillString(fornecedor.inscricaoMunicipal) !== fillString(inscricaoMunicipal)) && (refInscMun.current?.files?.length === undefined || refInscMun.current?.files?.length <= 0)
      || (fillString(fornecedor.inscricaoEstadual) !== fillString(inscricaoEstadual)) && (refInscEst.current?.files?.length === undefined || refInscEst.current?.files?.length <= 0)){
      showModalError("Atenção! Dados de cadastro alterados. Anexe um arquivo para realizar a solicitação.");
      e.preventDefault();
      return;
    }

    api(usuario)
      .post("/usuario/dadosCadatrais", formData)
      .then((resp) => {
        if (resp.status === 200) {
          showModalMessage("Alteração de dados", <h2>Solicitação de alteração efetuada, aguarde a validação dos dados.</h2>);
          navigate("/listarDocumentos");
        } else {
          showModalError(resp.data);
        }
      })
      .catch((error) => {
        showModalError("Erro ao acessar servidor");
      });
    e.preventDefault();
  };
  const Exclamacao = () => {
    if (alteracoes?.status === "APROVADO") 
    return <FaCheckCircle className="fa-success ms-1 mb-1" title="Alterado com sucesso" />;
    if (alteracoes?.status === "REPROVADO")
    return <FaTimesCircle className="fa-error ms-1 mb-1" title="Reprovado" />;
    else
    return <FaExclamationTriangle className="fa fa-exclamation-triangle ms-1 mb-1" title="Aguardando aprovação" />;
  };
  const InputRazaoSocial = (
    <div className="form-group">
      <label className="form-label mt-4">Razão Social</label>
      {alteracoes && alteracoes?.razaoSocial !== fornecedor.razaoSocial && <Exclamacao />}
      <div className="input-group  rounded-top">
        <input
          type="text"
          className={`form-control borda-cinza ${showAnexo ? "rounded-only-top" : ""}`}
          disabled={(razaoDisabled || !canEdit) && alteracoes?.status === "PENDENTE"}
          onChange={(e) => setRazaoSocial(e.currentTarget.value)}
          value={razaoSocial}
        />
        {fillString(fornecedor.razaoSocial) !== fillString(razaoSocial) && (
          <span className="input-group-text">
            <FiEdit />
          </span>
        )}
        { fillString(fornecedor.razaoSocial) !== fillString(razaoSocial) && (
          <button
            type="button"
            className={`btn btn-primary px-2 ${showAnexo ? "rounded-only-top" : ""}`}
            onClick={() => setShowAnexo(!showAnexo)}
            disabled={!canEdit}
          >
            Anexar
          </button>
        )}
      </div>
      <div className={`form-row altera-dados-form-wrap-inputfile ${!showAnexo ? "hidden" : ""}`}>
        <div className="form-group col-md-8 mb-0"></div>
        <input
          type="file"
          ref={refRazao}
          onChange={() => {
            setRazaoDisabled(refRazao.current?.files?.length === undefined || refRazao.current?.files?.length <= 0);
          }}
        />
      </div>
    </div>
  );
  const InputInscricaoMunicipal = (
    <div className="form-group">
      <label className="form-label mt-4">Inscrição Municipal</label>
      {alteracoes && alteracoes?.inscricaoMunicipal !== fornecedor.inscricaoMunicipal && <Exclamacao/>}
      <div className="input-group  rounded-top">
        <input
          type="text"
          className={`form-control borda-cinza ${showAnexoInscMun ? "rounded-only-top" : ""}`}
          disabled={(inscMunDisabled||!canEdit) && alteracoes?.status === "PENDENTE"}
          value={inscricaoMunicipal}
          onChange={(e) => setInscricaoMunicipal(e.currentTarget.value)}
        />
        {fillString(fornecedor.inscricaoMunicipal) !== fillString(inscricaoMunicipal) && (
          <span className="input-group-text">
            <FiEdit />
          </span>
        )}
        {fillString(fornecedor.inscricaoMunicipal) !== fillString(inscricaoMunicipal) && (
          <button
            type="button"
            className={`btn btn-primary px-2 ${showAnexoInscMun ? "rounded-only-top" : ""}`}
            onClick={() => setShowAnexoInscMun(!showAnexoInscMun)}
            disabled={!canEdit}
          >
            Anexar
          </button>
        )}
      </div>
      <div className={`form-row altera-dados-form-wrap-inputfile ${!showAnexoInscMun ? "hidden" : ""}`}>
        <div className="form-group col-md-8 mb-0"></div>
        <input
          type="file"
          ref={refInscMun}
          onChange={() => {
            setInscMunDisabled(refInscMun.current?.files?.length === undefined || refInscMun.current?.files?.length <= 0);
          }}
        />
      </div>
    </div>
  );
  const InputInscricaoEstadual = (
    <div className="form-group">
      <label className="form-label mt-4">Inscrição Estadual</label>
      {alteracoes && alteracoes?.inscricaoEstadual !== fornecedor.inscricaoEstadual && <Exclamacao/>}
      <div className="input-group rounded-top">
        <input
          type="text"
          className={`form-control borda-cinza ${showAnexoInscEst ? "rounded-only-top" : ""}`}
          disabled={(inscEstDisabled||!canEdit) && alteracoes?.status === "PENDENTE"}
          value={inscricaoEstadual}
          onChange={(e) => setInscricaoEstadual(e.currentTarget.value)}
        />
        {fillString(fornecedor.inscricaoEstadual) !== fillString(inscricaoEstadual) && (
          <span className="input-group-text">
            <FiEdit />
          </span>
        )}
        {fillString(fornecedor.inscricaoEstadual) !== fillString(inscricaoEstadual) && (
          <button
            type="button"
            className={`btn btn-primary px-2 ${showAnexoInscEst ? "rounded-only-top" : ""}`}
            onClick={() => setShowAnexoInscEst(!showAnexoInscEst)}
            disabled={!canEdit}
          >
            Anexar
          </button>
        )}
      </div>
      <div className={`form-row altera-dados-form-wrap-inputfile ${!showAnexoInscEst ? "hidden" : ""}`}>
        <div className="form-group col-md-8 mb-0"></div>
        <input
          type="file"
          ref={refInscEst}
          onChange={() => {
            setInscEstDisabled(refInscEst.current?.files?.length === undefined || refInscEst.current?.files?.length <= 0);
          }}
        />
      </div>
    </div>
  );
  
  const Alerta = (alteracoes: AlteracaoCadastral)=> {
    if (alteracoes?.status === "APROVADO") return (
      <div className="alert alert-dismissible alert-success mt-4">
        <h4 className="alert-heading">Sucesso!</h4>
        <br />
        <p className="mb-0">Prezado fornecedor!</p>
        <p className="mb-0">Sua última solicitação foi aprovada e seus dados foram atualizados.</p>
        <p className="mb-0">
          As informações em revisão estão assinaladas com o seguinte ícone: <Exclamacao />
        </p>
      </div>)    
    if (alteracoes?.status === "REPROVADO") return (
      <div className="alert alert-dismissible alert-danger mt-4">
        <h4 className="alert-heading">Aviso!</h4>
        <br />
        <p className="mb-0">Prezado fornecedor!</p>
        <p className="mb-0">Sua última solicitação foi reprovada e seus dados não foram atualizados. 
        Para mais informações entre em contato.</p>
        <p className="mb-0">
          As informações em revisão estão assinaladas com o seguinte ícone: <Exclamacao />
        </p>
      </div>)
    else return (
      <div className="alert alert-dismissible alert-warning mt-4">
        <h4 className="alert-heading">Aviso!</h4>
        <br />
        <p className="mb-0">Prezado fornecedor!</p>
        <p className="mb-0">Já existe uma solicitação de alteração cadastral em andamento.</p>
        <p className="mb-0">
          As informações em revisão estão assinaladas com o seguinte ícone: <Exclamacao />
        </p>
      </div>)
  }
  return (
    <>
      <h3 className="justify-self-center mx-auto altera-dados-top rounded-top">Meus Dados</h3>

      <form className="mt-0 p-4 pt-2 border" onSubmit={handleSubmit}>
        {alteracoes !== null ? (
          <Alerta {...alteracoes}/>
        ) : (
          <div className="alert alert-dismissible alert-primary mt-2">
            <p className="mb-0">
              Caso exista uma inconsistência em seus dados cadastrais, solicite a alteração através do envio deste formulário.
            </p>
          </div>
        )}
        <div className="form-group">
          <label className="form-label mt-2">CNPJ</label>
          <InputMask
                  maskPlaceholder={"*"}
                  mask="99.999.999/9999-99"
                  required
                  value={fornecedor.cnpj}
                  disabled
                >
                  {() => <input type="text" 
                    className="form-control borda-cinza" 
                    style={{backgroundColor: "#e9ecef"}} 
                    name="CNPJ" 
                    id="produto-1-cnpj" 
                  />}
                </InputMask>
        </div>

        {InputRazaoSocial}
        {InputInscricaoMunicipal}
        {InputInscricaoEstadual}
        <div className="form-group">
          <label className="form-label mt-4">Email</label>
          {alteracoes && alteracoes?.email !== fornecedor.email && <Exclamacao />}
          <div className="input-group">
            <input
              type="text"
              className="form-control borda-cinza"
              disabled={!canEdit}
              value={email}
              onChange={(e) => setEmail(e.currentTarget.value)}
            />
            {fillString(fornecedor.email) !== fillString(email) && (
              <span className="input-group-text">
                <FiEdit />
              </span>
            )}
          </div>
        </div>
        <fieldset style={{border:"2px solid #c0c0c0", borderRadius:"0.5rem", padding:'0.8rem', marginTop:'1rem'}}>
          <legend>Endereço</legend>
          <div className="form-group">
            <label className="form-label mt-4">Tipo</label>
            {alteracoes && alteracoes?.tipoLogradouro !== fornecedor.tipoLogradouro && <Exclamacao />}
            <div className="input-group">
              <input
                type="text"
                className="form-control borda-cinza"
                disabled={!canEdit}
                value={tipoLogradouro}
                onChange={(e) => setTipoLogradouro(e.currentTarget.value)}
              />
              {fillString(fornecedor.tipoLogradouro)!== fillString(tipoLogradouro) && (
                <span className="input-group-text">
                  <FiEdit />
                </span>
              )}
            </div>
          </div>
          <div className="form-group">
            <label className="form-label mt-4">Logradouro</label>
            {alteracoes && alteracoes?.rua !== fornecedor.rua && <Exclamacao />}
            <div className="input-group">
              <input
                type="text"
                className="form-control borda-cinza"
                disabled={!canEdit}
                value={rua}
                onChange={(e) => setRua(e.currentTarget.value)}
              />
              {fillString(fornecedor.rua) !== fillString(rua) && (
                <span className="input-group-text">
                  <FiEdit />
                </span>
              )}
            </div>
          </div>
          <div className="form-group">
            <label className="form-label mt-4">Número</label>
            {alteracoes && alteracoes?.numero !== fornecedor.numero && <Exclamacao />}
            <div className="input-group">
              <input
                type="text"
                className="form-control borda-cinza"
                disabled={!canEdit}
                value={numero}
                onChange={(e) => setNumero(e.currentTarget.value)}
              />
              {fillString(fornecedor.numero) !== fillString(numero) && (
                <span className="input-group-text">
                  <FiEdit />
                </span>
              )}
            </div>
          </div>
          <div className="form-group">
            <label className="form-label mt-4">Complemento</label>
            {alteracoes && alteracoes?.complemento !== fornecedor.complemento && <Exclamacao />}
            <div className="input-group">
              <input
                type="text"
                className="form-control borda-cinza"
                disabled={!canEdit}
                value={complemento}
                onChange={(e) => setComplemento(e.currentTarget.value)}
              />
              {fillString(fornecedor.complemento) !== fillString(complemento) && (
                <span className="input-group-text">
                  <FiEdit />
                </span>
              )}
            </div>
          </div>
          <div className="form-group">
            <label className="form-label mt-4">CEP</label>
            {alteracoes && alteracoes?.cep !== fornecedor.cep && <Exclamacao />}
            <div className="input-group">
              <input
                type="text"
                className="form-control borda-cinza"
                disabled={!canEdit}
                value={cep}
                onChange={(e) => setCep(e.currentTarget.value)}
              />
              {fillString(fornecedor.cep) !== fillString(cep) && (
                <span className="input-group-text">
                  <FiEdit />
                </span>
              )}
            </div>
          </div>
          <div className="form-group">
            <label className="form-label mt-4">Bairro</label>
            {alteracoes && alteracoes?.bairro !== fornecedor.bairro && <Exclamacao />}
            <div className="input-group">
              <input
                type="text"
                className="form-control borda-cinza"
                disabled={!canEdit}
                value={bairro}
                onChange={(e) => setBairro(e.currentTarget.value)}
              />
              {fillString(fornecedor.bairro) !== fillString(bairro) && (
                <span className="input-group-text">
                  <FiEdit />
                </span>
              )}
            </div>
          </div>
          <div className="form-group">
            <label className="form-label mt-4">Cidade</label>
            {alteracoes && alteracoes?.cidade !== fornecedor.cidade && <Exclamacao />}
            <div className="input-group">
              <input
                type="text"
                className="form-control borda-cinza"
                disabled={!canEdit}
                value={cidade}
                onChange={(e) => setCidade(e.currentTarget.value)}
              />
              {fillString(fornecedor.cidade) !== fillString(cidade) && (
                <span className="input-group-text">
                  <FiEdit />
                </span>
              )}
            </div>
          </div>
          <div className="form-group">
            <label className="form-label mt-4">Estado</label>
            {alteracoes && alteracoes?.estado !== fornecedor.estado && <Exclamacao />}
            <div className="input-group">
              <input
                type="text"
                className="form-control borda-cinza"
                disabled={!canEdit}
                value={estado}
                onChange={(e) => setEstado(e.currentTarget.value)}
              />
              {fillString(fornecedor.estado) !== fillString(estado) && (
                <span className="input-group-text">
                  <FiEdit />
                </span>
              )}
            </div>
          </div>   
          {(fornecedor.tipoLogradouro !== tipoLogradouro || fornecedor.rua !== rua || fornecedor.numero !== numero || 
            fornecedor.complemento !== complemento || fornecedor.cep !== cep || fornecedor.bairro !== bairro ||
            fornecedor.cidade !== cidade || fornecedor.estado !== estado) &&
            <> 
              <div className="form-group d-flex justify-content-center mt-4">
                <button type="button" className={`btn btn-primary px-2 ${showAnexoEndereco ? "rounded-only-top" : ""}`}
                style={{width:"50%"}} onClick={() => setShowAnexoEndereco(!showAnexoEndereco)}
                disabled={!canEdit}>
                  Anexar
                </button>
              </div>
              <div className={`form-row altera-dados-form-wrap-inputfile ${!showAnexoEndereco ? "hidden" : ""}`}>
              <div className="form-group col-md-8 mb-0"></div>
              <input
                type="file"
                ref={refEndereco}
                onChange={() => {
                  setEnderecoDisabled(refEndereco.current?.files?.length === undefined || refEndereco.current?.files?.length <= 0);
                }}
              />
              </div>
            </>
            }
        </fieldset>
        <div className="form-group d-flex justify-content-end mt-4">
          <button type="button" className="btn btn-secondary me-2" onClick={() => navigate("/listarDocumentos")}>
            Voltar
          </button>
          {(alteracoes?.status === "APROVADO" || alteracoes?.status === "REPROVADO" || alteracoes == null) && (
            <button type="submit" className="btn btn-primary">
              Solicitar
            </button>
          )}
        </div>
      </form>
    </>
  );
};

export default CadastroForm;
